/** Visible FAQ content; also emitted as FAQPage structured data (the two must stay identical). */
export const FAQ: ReadonlyArray<{ q: string; a: string }> = [
  {
    q: 'What is STRANGER?',
    a: 'STRANGER is a free stranger chat site. You are paired with a random person for a private one-to-one conversation by text or video. It is stranger talk without accounts, profiles or chat history.',
  },
  {
    q: 'Is stranger chat here free?',
    a: 'Yes. Talking to strangers on STRANGER is completely free and needs no sign-up, email or phone number.',
  },
  {
    q: 'Can I video chat with strangers?',
    a: 'Yes. Choose Video chat and your browser asks for camera and microphone access only when you press Start. Video travels directly between the two browsers over encrypted WebRTC and is never recorded.',
  },
  {
    q: 'How does interest matching work?',
    a: 'Add a few interests before you start. STRANGER first looks for a stranger who shares one of them; if nobody does within a few seconds, it matches you with anyone who is waiting in the same mode.',
  },
  {
    q: 'Is it safe to talk to strangers on STRANGER?',
    a: 'STRANGER is for adults only (18+). Every chat has one-tap Report and Block buttons, people reported by several users are suspended automatically, and your messages are never stored. Keep personal details to yourself and press Next whenever you want.',
  },
  {
    q: 'Is STRANGER an Omegle alternative?',
    a: 'Yes. STRANGER offers the same instant random text and video chat with strangers, with interest matching, Next and Stop controls, and modern safety tools built in.',
  },
];
